import React from "react";


// Every message that the user sends is passed through the MessageParser's parse function.
// Inside of this function you can provide a ruleset that decides which action to trigger. 

const MessageParser = ({ children, actions }) => {
  const parse = (message) => {
    if (message.includes("hello") || message.includes("hi") || message.includes("hey")) {
      actions.handleHello();
    }

    if (message.includes("Gaurav")){
      actions.handleGaurav();
    }
  };

  return (
    <div>
      {React.Children.map(children, (child) => {
        return React.cloneElement(child, {
          parse: parse,
          actions,
        });
      })}
    </div>
  );
};

export default MessageParser;
